import { render, staticRenderFns } from "./SroSummary.vue?vue&type=template&id=1fae6870&scoped=true&"
import script from "./SroSummary.vue?vue&type=script&lang=js&"
export * from "./SroSummary.vue?vue&type=script&lang=js&"
import style0 from "./SroSummary.vue?vue&type=style&index=0&id=1fae6870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae6870",
  null
  
)

export default component.exports